import BaseReelsConfig from "../../vendor_core/core/src/baseConfigs/BaseReelsConfig";
import IReelCascadeProps from "../../vendor_core/core/src/managers/contracts/configurations/reels/IReelCascadeProps";
import { Ease } from "../../vendor_core/core/src/Ease";

class ReelsConfig extends BaseReelsConfig {
    numberOfReels: number = 6;
    numberOfSymbols: number = 4;
    cascadeProps: IReelCascadeProps = {
        ...this.cascadeProps,
        mainSpinProps: {
            ...this.cascadeProps.mainSpinProps,
            spinReelDelay: 50,
            stopReelDelay: 50,
            spinSymbolAnimTime: 300,
            spinFirstSymbolAnimTime: 300,
            stopFirstSymbolAnimTime: 200,
            spinReelDelayInTurboMode: 20,
            stopReelDelayInTurboMode: 20,
            spinSymbolAnimTimeInTurboMode: 200,
            stopSymbolAnimTimeInTurboMode: 100,
            mainDropSpinEasing: "none",
            mainDropStopEasing: "back.out(0.4)",
            mainDropSpinEasingInTurboMode: Ease.None,
            mainDropStopEasingInTurboMode: Ease.None
        },
        dropRemainingProps: {
            ...this.cascadeProps.dropRemainingProps,
            easing: "back.out(0.6)",
            animationDuration: 200,
            animationDurationInTurbo: 100,
            delay: 20,
            delayInTurbo: 10
        },
        fillRemainingProps: {
            ...this.cascadeProps.fillRemainingProps,
            easing: "back.out(0.4)",
            easingInTurboMode: "back.out(0.6)",
            animTime: 200,
            animTimeInTurbo: 100,
            symbolDelay: 15,
            symbolDelayInTurboMode: 1,
            reelDelay: 30,
            reelDelayInTurboMode: 30
        }
    };
}

export default new ReelsConfig();
